module.exports = __webpack_public_path__ + "img/Product3.d1c25ede.svg";